import styled from "@emotion/styled";

export const InputStyles = styled("div")`
  .input {
    padding: 10.5px 14px 9.5px;
    border-radius: 6px;
    border: solid 1.5px rgba(51, 51, 204, 0.5);
    box-sizing: border-box;
    width: 100%;

    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.53;
    letter-spacing: 0.2px;
    color: #373785;

    &.-error {
      border-color: red;
    }
  }
`;
